module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "distributor-info"
  }, [_c('router-link', {
    staticClass: "back-to-list",
    attrs: {
      "to": {
        name: 'distributorManager'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "arrow-left"
    }
  }, [_vm._v("返回分销商列表")])], 1), _vm._v(" "), _c('div', {
    staticClass: "edit-info"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s((_vm.check ? '分销商信息' : (!_vm.infoId ? '添加' : '编辑') + '分销商')))]), _vm._v(" "), _c('el-form', {
    ref: "infoForm",
    staticClass: "items",
    attrs: {
      "model": _vm.infoForm,
      "rules": _vm.infoRules,
      "label-width": "93px",
      "label-position": "right"
    }
  }, [_vm._l((_vm.keyTxt), function(item, key) {
    return _c('el-form-item', {
      key: key,
      staticClass: "item",
      attrs: {
        "prop": key,
        "label": item.txt
      }
    }, [(key === 'brokerageRatio') ? _c('el-select', {
      attrs: {
        "name": key,
        "placeholder": item.placeholder,
        "disabled": !!_vm.check
      },
      model: {
        value: (_vm.infoForm[key]),
        callback: function($$v) {
          _vm.$set(_vm.infoForm, key, $$v)
        },
        expression: "infoForm[key]"
      }
    }, _vm._l((_vm.percentData), function(percent) {
      return _c('el-option', {
        key: percent,
        attrs: {
          "label": percent,
          "value": percent
        }
      })
    })) : _vm._e(), _vm._v(" "), (key === 'appRatio') ? _c('el-select', {
      attrs: {
        "name": key,
        "placeholder": item.placeholder,
        "disabled": !!_vm.check
      },
      on: {
        "change": _vm.turnSwitch
      },
      model: {
        value: (_vm.infoForm[key]),
        callback: function($$v) {
          _vm.$set(_vm.infoForm, key, $$v)
        },
        expression: "infoForm[key]"
      }
    }, _vm._l((_vm.percentData2), function(percent) {
      return _c('el-option', {
        key: percent,
        attrs: {
          "label": percent,
          "value": percent
        }
      })
    })) : _vm._e(), _vm._v(" "), (key != 'appRatio' && key != 'brokerageRatio') ? _c('el-input', {
      attrs: {
        "placeholder": item.placeholder,
        "name": key,
        "size": "small",
        "disabled": !!_vm.check || !!_vm.infoId && (key === 'idCardNo' || key === 'mobile')
      },
      model: {
        value: (_vm.infoForm[key]),
        callback: function($$v) {
          _vm.$set(_vm.infoForm, key, $$v)
        },
        expression: "infoForm[key]"
      }
    }) : _vm._e(), _vm._v(" "), (key === 'idCardNo' && !_vm.check) ? _c('p', {
      staticClass: "idNumber-sign"
    }, [_vm._v("*仅添加是可以编辑，后续只读，不可修改")]) : _vm._e(), _vm._v(" "), (key === 'brokerageRatio' && !_vm.check) ? _c('p', {
      staticClass: "percent-sign"
    }, [_vm._v("\n          指该分销商带来的的销售额中，需要按照该设置项来结算给该分销商的金额。该比例不能超过您与喜马拉雅的分成比例。")]) : _vm._e(), _vm._v(" "), (key === 'appRatio' && !_vm.check) ? _c('p', {
      staticClass: "percent-sign"
    }, [_vm._v("\n          分成比例设置为0时，分销商不会看到绑定用户和APP内订单信息；分成比例不为0，分销商将直接获得收益并看到其带来的绑定用户和APP内订单信息。")]) : _vm._e()], 1)
  }), _vm._v(" "), (!_vm.check) ? _c('div', {
    staticClass: "handle-footer"
  }, [_c('el-button', {
    staticClass: "submit",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取消")])], 1) : _vm._e()], 2)], 1), _vm._v(" "), (_vm.infoId) ? _c('div', {
    staticClass: "amendment-record"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("分成比例修改记录")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "modifiedAt",
      "label": "修改时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "newBrokerageRatio",
      "label": "分成比例",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modifierName",
      "label": "修改人"
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44f17478","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/distributorMana/distributorInfo.vue
// module id = 939
// module chunks = 1